

export type MarketTabType = 'for-sale' | 'sold' | 'removed'

interface MarketTab {
  id: MarketTabType
  label: string
  count?: number
  colorScheme: {
    active: string
    inactive: string
    activeText: string
    inactiveText: string
  }
}

interface MarketTabsProps {
  activeTab: MarketTabType
  onTabChange: (tab: MarketTabType) => void
  counts?: {
    forSale: number
    sold: number
    removed: number
  }
}

const tabs: MarketTab[] = [
  {
    id: 'for-sale',
    label: 'Currently on Market',
    colorScheme: {
      active: 'bg-green-700',
      inactive: 'bg-green-900/50 hover:bg-green-800/70',
      activeText: 'text-white',
      inactiveText: 'text-green-200'
    }
  },
  {
    id: 'sold',
    label: 'Aircraft Sold',
    colorScheme: {
      active: 'bg-blue-700',
      inactive: 'bg-blue-900/50 hover:bg-blue-800/70',
      activeText: 'text-white',
      inactiveText: 'text-blue-200'
    }
  },
  {
    id: 'removed',
    label: 'Removed from Market',
    colorScheme: {
      active: 'bg-amber-700',
      inactive: 'bg-amber-900/50 hover:bg-amber-800/70',
      activeText: 'text-white',
      inactiveText: 'text-amber-200'
    }
  }
]

export default function MarketTabs({ activeTab, onTabChange, counts }: MarketTabsProps) {
  const getCount = (tabId: MarketTabType): number | undefined => {
    if (!counts) return undefined
    switch (tabId) {
      case 'for-sale': return counts.forSale
      case 'sold': return counts.sold
      case 'removed': return counts.removed
      default: return undefined
    }
  }

  return (
    <div className="flex items-center space-x-2">
      {tabs.map((tab) => {
        const isActive = activeTab === tab.id
        const count = getCount(tab.id)

        return (
          <button
            key={tab.id}
            onClick={() => onTabChange(tab.id)}
            className={`
              px-3 py-1.5 rounded-md font-medium text-sm transition-colors duration-150
              ${isActive
                ? `${tab.colorScheme.active} ${tab.colorScheme.activeText}`
                : `${tab.colorScheme.inactive} ${tab.colorScheme.inactiveText}`
              }
            `}
          >
            <span>{tab.label}</span>
            {count !== undefined && (
              <span className={`ml-2 px-2 py-0.5 rounded-full text-xs font-semibold ${
                isActive ? 'bg-white/20' : 'bg-black/20'
              }`}>
                {count}
              </span>
            )}
          </button>
        )
      })}
    </div>
  )
}

